// Service hook (TS-2.5.01, Resource Accessor layer) - GET /api/projects/owners
// (ProjectsController.ListOwnersAsync, D-249/D-250: distinct owner display names, case/whitespace-
// collapsed, most-frequent spelling shown) feeding the Owner field's suggestions. Fetched once per
// form mount rather than wired to push-channel invalidation like useReferenceList - the owner list
// is a same-session convenience list, not a vocabulary the save path validates against, and per
// D-229 the server remains the authority: a failed fetch here must not block the field, which stays
// free text either way.
import { useEffect, useState } from "react";
import type { ProjectOwnerSummary } from "../../../api/generated/contracts";
import { portfolioDataApi } from "../../../api/portfolioData";

export interface UseOwnerSuggestionsResult {
  readonly owners: readonly ProjectOwnerSummary[];
}

export function useOwnerSuggestions(): UseOwnerSuggestionsResult {
  const [owners, setOwners] = useState<readonly ProjectOwnerSummary[]>([]);

  useEffect(() => {
    let cancelled = false;

    void portfolioDataApi
      .listOwners()
      .then((next) => {
        if (!cancelled) setOwners(next);
      })
      .catch(() => {
        // A failed owner-suggestions fetch is not fatal - the Owner field stays a usable free-text
        // input either way (same posture as useReferenceList's vocabulary fetch).
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { owners };
}
